import * as z from 'zod'

/**
 * Schema for a vendor pixel object used in tracking.
 * @property key - Identifier for the vendor pixel
 * @property clickEventUrl - URL to be called when a click event occurs
 * @property pageViewUrl - URL to be called on page load (optional)
 */
export const VendorPixelSchema = z.object({
  key: z.string(),
  clickEventUrl: z.string(),
  pageViewUrl: z.string().optional(),
})

export type VendorPixel = z.infer<typeof VendorPixelSchema>
